/**
 * Utilities for working with `string`s.
 *
 * @module @sorrell/utilities/string
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export * from "./String.ts";
